import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { BlogListStack } from "../../../components/BlogListStack";

const PageCategories = ({ pageData }) => {
  const data = useStaticQuery(
    graphql`
      query {
        allContentfulBlogPosts(
          sort: { fields: publishDate, order: DESC }
          filter: { isDraft: { ne: true } }
        ) {
          nodes {
            createdAt
            isDraft
            isHeaderDark
            languagePreference
            publishDate
            title
            excerptContentOptions
            excerpt {
              raw
            }
            introTextStyling {
              fontSize
              lineHeight
              content {
                content
              }
            }
            outroTextStyling {
              fontSize
              lineHeight
              content {
                content
              }
            }
            intro {
              intro
            }
            blogBodyContent {
              textContent {
                textContent
              }
            }
            thumbnailImage {
              gatsbyImageData(width: 2400, quality: 100)
            }
            blogPostUrlSlug
            categories {
              title
            }
            parentCategory {
              categoryName
              slugId
            }
          }
        }
        allContentfulBlogCategories(
          sort: { fields: createdAt, order: ASC }
          filter: {
            title: {
              in: ["Cool Beans News", "Coffee Competitions", "Coffee Expos"]
            }
          }
        ) {
          nodes {
            id
            title
            languagePreference
          }
        }
      }
    `
  );

  const languagePreference = 'English';

  const filteredCategories = data.allContentfulBlogCategories.nodes.filter(cat => {
    if (languagePreference === 'English') {
      return cat.languagePreference === 'English';
    } else {
      return cat.languagePreference === 'International';
    }
  });

  let singleCatData = data.allContentfulBlogPosts.nodes.filter(item => {
    return item.parentCategory.categoryName !== 'Savor Stories' && item.parentCategory.categoryName !== 'Packaging Tips';
  });

  return (
    <BlogListStack 
      data={singleCatData} 
      dataCat={filteredCategories}
      blogTitle={pageData.headerPageTitle}
      hasCatFilter={true}
    />
  );
};

export default PageCategories;
